import { render, staticRenderFns } from "./SettingViewSidebar.vue?vue&type=template&id=05a646c5&scoped=true"
import script from "./SettingViewSidebar.vue?vue&type=script&lang=js"
export * from "./SettingViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./SettingViewSidebar.vue?vue&type=style&index=0&id=05a646c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a646c5",
  null
  
)

export default component.exports